/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Export_Preset_LoadedInputs */



/**
* | output |
* | --- |
* | "Video export preset \"{name}\" loaded" |
*
* @param {Video_Export_Export_Preset_LoadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_loaded = /** @type {((inputs: Video_Export_Export_Preset_LoadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_LoadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prereglage d'exportation video "${i?.name}" charge`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videoexport-Voreinstellung "${i?.name}" geladen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Preimpostazione di esportazione video "${i?.name}" caricata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загружена предустановка экспорта видео "${i?.name}".`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se cargó el ajuste preestablecido de exportación de vídeo "${i?.name}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频导出预设“${i?.name}”已加载`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオエクスポートプリセット「${i?.name}」が読み込まれました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रीसेट "${i?.name}" लोड हो गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinição de exportação de vídeo "${i?.name}" carregada`)
	return /** @type {LocalizedString} */ (`Video export preset "${i?.name}" loaded`)
});